const initialState = {
  fetching: false,
};

export default function practiceExerciseReducer(currentState = initialState, action) {
  switch (action.type) {
    case 'PRACTICEEXERCISE_FETCHING':
      return { ...currentState, fetching: true };
    case 'PRACTICEEXERCISE_FETCHED':
      return { ...currentState, data: action.payload.data, fetching: false };
    default:
      return currentState;
  }
}
